<template>
  <div class="ml-3">
    <div class="ml-2 mb-2">
      <span class="orange-icon orange-icon-badge-align fa fa-info-circle" />
      <strong class="py-2 pl-2 font-16">Certificación de Visita</strong>
    </div>
    <div class="pl-md-2 mr-md-3 mt-md-4 mb-md-4 bg-white">
      <validation-observer ref="visitDocumentForm" v-slot="{}" tag="form">
        <div
          v-if="
            document.isElectronicsSignature &&
              document.digitalSignatureDocumentStatusId ==
                digitalSignatureStatusFirmado
          "
          class="col-12 col-md-12"
        >
          <div class="row mr-md-0 ml-n0 ml-md-n4 ml-0">
            <div class="col-2 my-2">
              <div class="color-gray-6 font-14">Tipo de Documento:</div>
              <div class="color-black font-16 font-weight-bold">
                {{ document.documentTypeName | empty }}
              </div>
            </div>
            <div class="col-6 my-2">
              <div class="color-gray-6 font-14">Nombre del Archivo:</div>
              <div class="color-black font-16 font-weight-bold">
                {{ document.documentFileName | empty }}

                <action-button
                  id="btn-download-document"
                  class="btn-action-size mr-2 downloadbutton"
                  i="fas fa-file-download downloadbutton-i"
                  variant="success"
                  @click="onDownloadFile(document.documentId)"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="!document.isElectronicsSignature" class="row mt-0 mb-5">
          <div class="col-md-3 col-sm-12">
            <validation-provider
              v-slot="{ errors }"
              name="documentType"
              rules="required"
            >
              <custom-drop-down
                v-model="documentTypeSelected"
                custom-error-msg="El tipo de documento es requerido."
                :disabled="true"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Documento:"
                :options="documentTypesOptions"
              />
            </validation-provider>
          </div>
          <div class="col-md-6 col-sm-12 file-custom">
            <validation-provider
              v-slot="{ errors }"
              name="fileUpload"
              rules="required"
            >
              <custom-file-input
                ref="proRemfileUpload"
                accept=".pdf"
                accept-terms-modal-title="Certificación"
                accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                accept-terms-title="Acepto los términos y responsabilidades"
                accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                allow-accept-terms
                :attachment-id="document.documentId"
                :custom-error-msg="'El documento es requerido.'"
                :disabled="readOnly"
                display-style="normal"
                :error="errors[0]"
                label="Archivo"
                label-position="left"
                :name="document.documentFileName"
                :on-download="onDownloadFile"
                required
                :value="document.attachment"
                @input="onChangeFile"
              />
            </validation-provider>
          </div>
          <div class="col-md-3 col-sm-12 align-self-end">
            <div
              v-if="!document.documentId"
              class="row justify-content-center ml-2"
            >
              <div v-if="!readOnly" class="col-md-6">
                <action-button
                  id="certification-cancel-btn"
                  class="float-right"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="outline-danger"
                  @click="$emit('on-cancel')"
                />
              </div>
              <div class="col-md-6">
                <action-button
                  id="certification-save-btn"
                  i="fas fa-save fa-lg"
                  text="Guardar"
                  variant="success"
                  @click="onSaveDocument"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            document.isElectronicsSignature &&
              document.digitalSignatureDocumentStatusId !=
                digitalSignatureStatusFirmado
          "
          class="row"
        >
          <RowMessage
            class="mt-0 col-lg-12"
            :text="
              `El documento de la certificación de visita estará disponible un vez sea firmado por todas las partes.`
            "
            warning
          />
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import objectToFormData from 'object-to-formdata';
import { getDocumentTypes } from '@/services/common/code.api.js';
import RowMessage from '@/components/common/RowMessage.vue';
import {
  getVisitCertificate as _getVisitCertificate,
  saveVisitCertificate as _saveVisitCertificate,
} from '@/services/provider/billing-contract.api';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
export default {
  name: 'VisitCertification',
  mixins: [alertMixin],
  components: {
    CustomDropDown,
    ActionButton,
    CustomFileInput,
    RowMessage,
  },
  data() {
    return {
      documentTypesOptions: [],
      documentTypeSelected: null,
      document: {
        contractId: null,
        visitSummaryId: null,
        academicYearId: null,
        documentId: null,
        documentFileName: null,
        documentTypeId: null,
        attachment: null,
        isElectronicsSignature: null,
        documentTypeName: null,
        digitalSignatureDocumentId: null,
        digitalSignatureDocumentStatusId: null,
      },
      digitalSignatureStatusFirmado: 5,
    };
  },
  props: {
    input: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    // Certificación de visita
    await getDocumentTypes([89]).then(({ data }) => {
      this.documentTypesOptions = data;
      this.documentTypeSelected = this.documentTypesOptions[0];
    });

    await _getVisitCertificate(
      this.input.contractId,
      this.input.specialistId,
      this.input.visitSummaryId
    ).then((resp) => {
      if (resp) {
        this.document = {
          contractId: this.input.contractId,
          visitSummaryId: this.input.visitSummaryId,
          academicYearId: this.input.academicYearId,
          documentId: resp.data.documentId,
          documentFileName: resp.data.documentFilename,
          documentTypeId: resp.data.documentTypeId,
          isElectronicsSignature: resp.data.isElectronicsSignature,
          documentTypeName: resp.data.documentTypeName,
          digitalSignatureDocumentId: resp.data.digitalSignatureDocumentId,
          digitalSignatureDocumentStatusId:
            resp.data.digitalSignatureDocumentStatusId,
        };
      }
    });
  },
  methods: {
    onDownloadFile(id) {
      if (id) {
        return new Promise((resolve, reject) => {
          _downloadDocumentByAttachmentId(id)
            .then(() => resolve())
            .catch((err) => reject(err));
        });
      }
    },
    onChangeFile(file) {
      if (file) {
        this.document.documentTypeId = this.documentTypeSelected.id;
        this.document.documentFileName = file.name;
        this.document.attachment = file;
      } else {
        this.document.documentId = null;
        this.document.documentFileName = null;
        this.document.attachment = null;
      }
    },
    async onSaveDocument() {
      const isValid = await this.$refs.visitDocumentForm.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const payload = objectToFormData(
        {
          contractId: this.input.contractId,
          visitSummaryId: this.input.visitSummaryId,
          academicYearId: this.input.academicYearId,
          documentId: this.document.documentId,
          documentFileName: this.document.documentFileName,
          documentTypeId: this.document.documentTypeId,
          attachment: this.document.attachment,
          specialistId: this.input.specialistId,
        },
        { indices: true, nullsAsUndefineds: true }
      );
      await _saveVisitCertificate(payload)
        .then(() => {
          this.ShowToast(
            'Proceso exitoso.',
            'El documento ha sido guardado exitosamente.',
            'success'
          );
          this.$emit('on-save');
        })
        .catch((err) =>
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          )
        );
    },
  },
};
</script>

<style scopped>
.input-label {
  font-size: 14px !important;
  color: #727272 !important;
}

.orange-icon {
  color: var(--orange);
}
.downloadbutton {
  margin-left: 10px !important;
}
.downloadbutton-i {
  margin-left: 7px !important;
}
</style>
